import { render } from "./Contactos.vue?vue&type=template&id=581fdb3c&scoped=true"
import script from "./Contactos.vue?vue&type=script&lang=js"
export * from "./Contactos.vue?vue&type=script&lang=js"

import "./Contactos.vue?vue&type=style&index=0&id=581fdb3c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-581fdb3c"

export default script